import React from "react";
import {Button} from "@progress/kendo-react-buttons";
import {buttonThemeColors} from "../../base/Button/Button.jsx";
import {useFormikContext} from "formik";

export const ResetButton = ({ children = 'Reset', themeColor = buttonThemeColors.secondary, disabled, ...otherProps }) => {
    const { resetForm, dirty, isSubmitting } = useFormikContext();

    const handleReset = async () => {
        if(otherProps.onReset) await otherProps.onReset();
        resetForm();
    };

    return (
        <Button
            type="button"
            themeColor={themeColor}
            disabled={!dirty || isSubmitting || disabled}
            onClick={handleReset}
            {...otherProps}
        >
            {children}
        </Button>
    );
};